// extracted by mini-css-extract-plugin
export default {"avatar":"ProfileImage_avatar__2QrSB"};